export const REACTION_NAME_CANDLE = 'candle'
export const REACTION_NAME_HAHA = 'haha'
export const REACTION_NAME_INTERESTING = 'interesting'
export const REACTION_NAME_LIKE = 'like'
export const REACTION_NAME_OH_NO = 'oh_no'
export const REACTION_NAME_OLD_HEART = 'old_heart'
export const REACTION_NAME_WOW = 'wow'
export const REACTION_NAME_THUMBS_UP = 'thumbs_up'
export const REACTION_NAME_THUMBS_DOWN = 'thumbs_down'
